import React, { useState, useEffect } from "react";
import {
    Box,
    Input,
    Button,
    TokenGroup,
    SpaceBetween
} from "@amzn/awsui-components-react";
import { BannerCustomMultiInputProps, UrlPrefix } from "./BannerTypes";

export const BannerCustomMultiInput = (props: BannerCustomMultiInputProps) => {
    const [inputs, setInputs] = useState<UrlPrefix[]>([]);
    const [currentInput, setCurrentInput] = useState<string>("/");
    const [inputSet, setInputSet] = useState<Set<string>>(new Set([]))

    useEffect(() => {
        setInputs(props.getInputs())
    }, []);

    useEffect(() => {
        setInputSet(new Set([...(inputs.map(input => input.label.toLowerCase()))]))
        props.updateInputs(inputs)
    }, [inputs])

    const addUrlPrefix = (urlPrefix: string) => {
        setInputs([...inputs, {label: urlPrefix}]);
        setCurrentInput("/");
    }

    const invalidUrlPrefix = (proposedUrl: string): boolean => {
        const pathPart = proposedUrl.substring(1);
        if (
            inputSet.has(proposedUrl.toLowerCase()) 
            || !proposedUrl 
            || typeof proposedUrl !== 'string'
            || !proposedUrl.startsWith('/')
            || pathPart.length === 0
        ) {
            return true;
        }
        
        const lettersOnlyRegex = /^[a-zA-Z]+$/;
        return !lettersOnlyRegex.test(pathPart);
    }

    return (
        <Box>
            <SpaceBetween size="m">
                <Box>
                    <SpaceBetween size="m"direction="horizontal">
                        <Input
                            onChange={(event) => setCurrentInput(event.detail.value)}
                            inputMode="url"
                            value={currentInput}
                        ></Input>
                        <Button 
                            variant="primary" 
                            disabled={invalidUrlPrefix(currentInput)} 
                            onClick={() => addUrlPrefix(currentInput)}
                        >Add</Button>
                    </SpaceBetween>

                </Box>
                <Box>
                    { inputs.length > 0 && (
                        <TokenGroup
                            items={inputs}
                            onDismiss={({ detail: { itemIndex } }) => {
                                setInputs([
                                    ...inputs.slice(0, itemIndex),
                                    ...inputs.slice(itemIndex + 1)
                                ]);
                            }}
                        />
                    )}
                </Box>
            </SpaceBetween>
        </Box>
    )
}

export default BannerCustomMultiInput;
